@import 'styles/mixins';
@import 'styles/variables';

.icon {
  fill: $grey-40;
}
